export const MAX_INVENTORY_QUANTITY = 2147483647;

export function isPositivePurchasePrice(value) {
  if (value == null || value === '') return false;
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0;
}

export function parseInventoryQuantity(value, { allowZero = false } = {}) {
  const text = String(value ?? '').trim();
  if (!/^\d+$/.test(text)) return null;
  const quantity = Number(text);
  return Number.isSafeInteger(quantity) &&
    quantity <= MAX_INVENTORY_QUANTITY &&
    quantity >= (allowZero ? 0 : 1)
    ? quantity
    : null;
}

/** Parse the entire amount; never silently truncate spaces, decimal parts or trailing text. */
export function parseInventoryMoney(value) {
  if (typeof value === 'number') return Number.isFinite(value) && value >= 0 ? value : null;
  let text = String(value ?? '')
    .trim()
    .replace(/\s/g, '');
  if (!text) return null;
  if (/^\d{1,3}(?:,\d{3})+\.\d+$/.test(text)) text = text.replace(/,/g, '');
  else if (/^\d{1,3}(?:\.\d{3})+,\d+$/.test(text)) text = text.replace(/\./g, '').replace(',', '.');
  else if (/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(text)) text = text.replace(',', '.');
  else return null;
  const amount = Number(text);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
}
